module.exports = __webpack_public_path__ + "img/selfAdhesive8.ef5423b7.jpg";